import {Component, Input} from '@angular/core';
import {CartService} from '../cart.service';
import {Cart} from '../Cart';
import {CurrencyPipe} from "@angular/common";

@Component({
  selector: 'app-total',
  templateUrl: './total.component.html',
  styleUrls: ['./total.component.scss'],
  standalone: true,
  imports: [
    CurrencyPipe
  ]
})
export class TotalComponent {

  private _cart: Cart;

  subtotal: number;
  tax: number;
  total: number;

  constructor(private readonly cartService: CartService) {
  }

  get cart(): Cart {
    return this._cart;
  }

  @Input()
  set cart(given: Cart) {
    this._cart = given;

    if (this.cart) {
      const cartTotals = this.cartService.calcTotals(this.cart);
      this.subtotal = cartTotals.subtotal;
      this.tax = cartTotals.tax;
      this.total = cartTotals.total;
    } else {
      this.subtotal = this.tax = this.total = 0;
    }
  }

}
